import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";
export const styles = (theme: Theme) => {
	return {
		adornedEnd: {
			paddingRight: 5,
		},
		button: {
			paddingLeft: 15,
			paddingRight: 15,
		},
		labelAsterisk: {
			color: theme.palette.error.main,
		},
		errorMessage: {
			color: theme.palette.error.main,
			fontWeight: "bold",
		}
	} satisfies Record<string, CSSObject>;
};
